//we use this id for create unic name for multiselect
//only used for the ac selection
const report   = require ('../../../../../components/report/report')

var acUnicId = 0;

export function unpaid_invoices_list(id) {
  acUnicId++;
  return `

	<div class="line line-${acUnicId} tdClick" style="border:none;" lineId="${acUnicId}"  data-detail='{"click": [{"dest":"ripple"} ,{"dest":"accountsPayable",  "elem":"fullcont", "act":"purchaseFullcont2", "dbid":"${id}"}] }'> 

	    <div class="row">
	      	<div class="c20">

				<div class="textfield textfield-mini textfield-report date"  >

					<input autocomplete="off"  class= 'elem' type="text"
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }],
					"click": [ {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"click"}] }>'>

				</div><!-- textfield -->  

			</div><!-- c25 --> 

			<div class="c20">

				<div class="textfield textfield-mini textfield-report code"  >

					<input autocomplete="off" style="color:#0280ee !important;" class= 'elem' type="text">

				</div><!-- textfield -->  

			</div><!-- c25 --> 

			<div class="c20">

				<div class="textfield textfield-mini textfield-report due_date"  >

					<input autocomplete="off"  class= 'elem' type="text"
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }],
					"click": [ {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"click"}] }>'>

				</div><!-- textfield -->  

			</div><!-- c25 --> 

			<div class="c20">

				<div class="textfield textfield-mini textfield-report original_amount"  >

					<input autocomplete="off"  class= 'elem' type="text"
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }],
					"click": [ {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"click"}] }>'>

				</div><!-- textfield -->  

			</div><!-- c25 --> 

			<div class="c20">

				<div class="textfield textfield-mini textfield-report due_amount"  >

					<input autocomplete="off"  class= 'elem' type="text"
					data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }],
					"click": [ {"dest":"accountsPayable", "elem":"fullcont", "id":"accountsPayable-fullcont", "act":"click"}] }>'>

				</div><!-- textfield -->  

			</div><!-- c25 --> 
		  
	    </div><!-- row -->  


	</div><!-- line -->  
	`;
}
